<template>
  <div class="ac-wrapper">
    <ArticleAutocomplete
      :title="$t('component.article_autocomplete.title')"
      :default-collapsed="true"
      :track-event-context="CMP_CONTEXTS.ACTIVE_CONVERSATION"
    />
    <ResolvedRequestBanner />
    <ConversationList
      class="ac-conversation-list"
      :conversations="conversations"
      @select="$emit('select:ticket', $event)"
      @show:all="$emit('show:all', $event)"
    />
    <ACActions class="ac-actions" :disabled="count >= maxLimit" :max-limit="maxLimit" @new="$emit('new:ticket')" />
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import ACActions from './ACActions.vue';
import ConversationList from './ConversationList.vue';
import { Conversation } from './type';
import ArticleAutocomplete from '@/components/ArticleAutocomplete.vue';
import ResolvedRequestBanner from '@/components/ResolvedRequestBanner.vue';
import LogPageEventMixin, { PAGE_TRACKING, PAGE_EVENTS } from '@/mixins/logPageEvent';
import { mixins } from 'vue-class-component';
import { CMP_CONTEXTS } from '@/common/logs/events';

@Component({ components: { ConversationList, ACActions, ArticleAutocomplete, ResolvedRequestBanner } })
export default class ActiveConversations extends mixins(LogPageEventMixin) {
  @Prop({ default: 0 }) readonly count!: number;
  @Prop({ default: () => [] }) readonly conversations!: Conversation[];
  @Prop({ default: 99999 }) readonly maxLimit!: number;

  readonly [PAGE_TRACKING] = PAGE_EVENTS.ACTIVE_CONVERSATION_HOME;
  readonly CMP_CONTEXTS = CMP_CONTEXTS;

  created() {
    document.title = 'Active Conversations';
  }
}
</script>

<style lang="scss">
.ac-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  .ac-conversation-list {
    flex: 1 1 100%;
    overflow-y: auto;
  }

  .ac-actions {
    flex: 0 1 auto;
  }
}
</style>
